import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGeoStorageLocation } from '../../../../actions/geo';
import { approveLoad, setSelectedLoadIds } from '../../../../actions/load';

const LoadQueueContext = React.createContext();

export const useLoadQueueContext = () =>
	useContext(LoadQueueContext);


export const LoadQueueProvider = ({ children }) => {

	const [multiApporveData, setMultiApporveData] = useState({});
	const [approving, setApproving] = useState(false);
	const [isEdited, setIsEdited] = useState(false);
	const [editedLoadsById, setEditedLoadsById] = useState({});
	const loadList = useSelector(state => state.load.loadQueueList.data);
	const selectedLoadIds = useSelector(state => state.load.selectedLoadIds);
	const unLoadSiteList = useSelector(state => state.load.unLoadSiteList);
	const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);

	const dispatch = useDispatch();


	const handleMultiApprove = () => {
		setApproving(true);
		const seletedLoads = loadList.filter(item => selectedLoadIds.indexOf(item.loadActivityId) >= 0);
		const approvalLoads = seletedLoads.map(item => ({ ...item, ...editedLoadsById[item.loadActivityId] }));
		const data = [];

		approvalLoads.forEach(item => {
			const findShape = item.offloadGeoShapeId ? unLoadSiteList.filter(e => e.geo_shape_uuid === item.offloadGeoShapeId) : [];

			const offload_geo_region_name = (findShape.length > 0) ? findShape[0].geo_region_name : (item && item.offloadGeoRegionName) ? item.offloadGeoRegionName : null;
			const offload_geo_region_uuid = (findShape.length > 0) ? findShape[0].geo_region_uuid : (item && item.offloadGeoRegionId) ? item.offloadGeoRegionId : null;
			const offload_geo_shape_name = (findShape.length > 0) ? findShape[0].geo_shape_name : (item && item.offloadGeoShapeName) ? item.offloadGeoShapeName : null;

			const params = {
				farm_uuid: farmId,
				source_equipment_group_uuid: item.sourceEquipmentGroupId,
				target_equipment_group_uuid: item.targetEquipmentGroupId,
				load_activity_uuid: item.loadActivityId,
				load_capacity: item.loadCapacity,
				offload_geo_shape_uuid: item.offloadGeoShapeId,
				offload_geo_region_name,
				offload_geo_region_uuid,
				offload_geo_shape_name,
				offload_geo_storage_location_uuid: item.offloadStorageLocationId
			};
			data.push(params);
		});

		dispatch(approveLoad({ farm_uuid: farmId, loads: data }, (isApproved) => {
			if (isApproved) {
				// update offload default storage location
				const defaultStorageLocations = data.filter(e => e.offload_geo_storage_location_uuid === 'default');
				let geo_region_shape_uuid = defaultStorageLocations.map((item) => {
					const findShape = unLoadSiteList.find(e => e.geo_shape_uuid === item.offload_geo_shape_uuid) || {};
					return findShape.geo_shape_object_uuid;
				}).filter(geoShapeObjectId => Boolean(geoShapeObjectId));
				geo_region_shape_uuid = [...new Set(geo_region_shape_uuid)].join(',');

				geo_region_shape_uuid && dispatch(getGeoStorageLocation({ geo_region_shape_uuid }));

				dispatch(setSelectedLoadIds([]));
				setIsEdited(false);
			}
			setApproving(false);
		}));
	}

	const value = {
		multiApporveData, setMultiApporveData,
		approving, setApproving,
		isEdited, setIsEdited, handleMultiApprove,
		editedLoadsById, setEditedLoadsById
	};

	return (
		<LoadQueueContext.Provider value={value}>
			{children}
		</LoadQueueContext.Provider>
	)
}
